import { useEffect } from 'react';
import {
    useMap,
} from '@vis.gl/react-google-maps';
import { getTileUrl } from '../../../helpers/GeometryHelpers';
import { useActivateSeamap } from '../hooks/useMapStore';


export const MapProviders = () => {

    const activateSeamap = useActivateSeamap();
    
    return (
        <MapProviderSeaMap isSeamapActive={activateSeamap} />
    )
}

interface MapProviderSeaMapProps {
    isSeamapActive: boolean,
}

const MapProviderSeaMap = ({ isSeamapActive }: MapProviderSeaMapProps) => {

    const map = useMap();

    const seamap = new window.google.maps.ImageMapType({
        getTileUrl: getTileUrl,
        name: "Sj�kart",
        alt: "Norge / Sj?kart",
        minZoom: 0,
        maxZoom: 19,
        opacity: 1.0
    });

    useEffect(() => {
        if (!map) return;

        if (!isSeamapActive) {
            // remove
            map.overlayMapTypes.removeAt(0);
        } else {
            // add
            map.overlayMapTypes.push(seamap);
        }

    }, [isSeamapActive, map]);

    return null;
}
